import {hexColorToRGBA} from '../util.js'
import {componentStyle, seniorCfg} from '../common/common'
import {BASE_ECHARTS_SELECT, DEFAULT_TOOLTIP} from '@/views/chart/chart/chart'
import {valueFormatterWithoutSuffix} from "@/views/chart/chart/formatter";
import {getLanguage} from '@/lang'
import {getStrByLang} from '@/utils'

export function baseBarOption(chart_option, chart, activeParam) {
  // 处理shape attr
  let customAttr = {}
  if (chart.customAttr) {
    customAttr = JSON.parse(chart.customAttr)
    if (customAttr.color) {
      chart_option.color = customAttr.color.colors
    }
    // tooltip
    if (customAttr.tooltip) {
      const tooltip = JSON.parse(JSON.stringify(customAttr.tooltip))
      const reg = new RegExp('\n', 'g')
      tooltip.formatter = tooltip.formatter.replace(reg, '<br/>')
      chart_option.tooltip = tooltip

      const bgColor = tooltip.backgroundColor ? tooltip.backgroundColor : DEFAULT_TOOLTIP.backgroundColor
      chart_option.tooltip.backgroundColor = bgColor
      chart_option.tooltip.borderColor = bgColor
    }
  }

  // 处理自定义组件样式
  let customStyle = {}
  if (chart.customStyle) {
    customStyle = JSON.parse(chart.customStyle)
    if (customStyle.xAxis) {
      chart_option.xAxis.inverse = customStyle.xAxis.inverse
    }
    if (customStyle.yAxis) {
      chart_option.yAxis.inverse = customStyle.yAxis.inverse
    }
  }
  // 处理data
  if (chart.data) {
    chart_option.title.text = chart.title
    let yAxisData = [];
    chart.data.x.forEach(function (value) {
      let lvalue = getStrByLang(value)
      yAxisData.push(lvalue);
    });
    chart_option.xAxis.data = yAxisData
    for (let i = 0; i < chart.data.series.length; i++) {
      const y = chart.data.series[i]

      formatValue(y, chart)

      // color
      y.itemStyle = {
        color: hexColorToRGBA(customAttr.color.colors[i % customAttr.color.colors.length], customAttr.color.alpha)
      }

      if (customAttr.color.colorBy) {
        y.colorBy = customAttr.color.colorBy
        y.itemStyle = {}
      }
      // size
      if (customAttr.size) {
        if (customAttr.size.barDefault) {
          y.barWidth = null
          y.barGap = null
        } else {
          y.barWidth = customAttr.size.barWidth
          y.barGap = customAttr.size.barGap
        }
      }
      // label
      if (customAttr.label) {
        y.label = customAttr.label
      }
      y.type = 'bar'
      y.selectedMode = true
      y.select = BASE_ECHARTS_SELECT
      y.name=getStrByLang(y.name)
      y.label.formatter=getStrByLang(y.label.formatter)
      chart_option.legend.data.push(y.name)
      chart_option.series.push(y)
    }
  }
  componentStyle(chart_option, chart)
  seniorCfg(chart_option, chart)
  return chart_option
}

export function stackBarOption(chart_option, chart) {
  baseBarOption(chart_option, chart)

  // ext
  chart_option.series.forEach(function (s) {
    s.stack = 'stack'
    s.emphasis = {
      focus: 'series'
    }
  })
  return chart_option
}

export function horizontalBarOption(chart_option, chart) {
  // 处理shape attr
  let customAttr = {}
  if (chart.customAttr) {
    customAttr = JSON.parse(chart.customAttr)
    if (customAttr.color) {
      chart_option.color = customAttr.color.colors
    }
    if (customAttr.tooltip) {
      const tooltip = JSON.parse(JSON.stringify(customAttr.tooltip))
      const reg = new RegExp('\n', 'g')
      tooltip.formatter = tooltip.formatter.replace(reg, '<br/>')
      chart_option.tooltip = tooltip

      const bgColor = tooltip.backgroundColor ? tooltip.backgroundColor : DEFAULT_TOOLTIP.backgroundColor
      chart_option.tooltip.backgroundColor = bgColor
      chart_option.tooltip.borderColor = bgColor
    }
  }

  // 处理自定义组件样式
  let customStyle = {}
  if (chart.customStyle) {
    customStyle = JSON.parse(chart.customStyle)
    if (customStyle.xAxis) {
      chart_option.xAxis.inverse = customStyle.xAxis.inverse
    }
    if (customStyle.yAxis) {
      chart_option.yAxis.inverse = customStyle.yAxis.inverse
    }
  }

  // 处理data
  if (chart.data) {
    chart_option.title.text = chart.title

    let yAxisData = [];
    chart.data.x.forEach(function (value) {
      let lvalue = getStrByLang(value)
      yAxisData.push(lvalue);
    });

    chart_option.yAxis.data = yAxisData
    for (let i = 0; i < chart.data.series.length; i++) {
      const y = chart.data.series[i]

      formatValue(y, chart)
      // color
      y.itemStyle = {
        color: hexColorToRGBA(customAttr.color.colors[i % customAttr.color.colors.length], customAttr.color.alpha)
      }

      if (customAttr.color.colorBy) {
        y.colorBy = customAttr.color.colorBy
        y.itemStyle = {}
      }
      // size
      if (customAttr.size) {
        if (customAttr.size.barDefault) {
          y.barWidth = null
          y.barGap = null
        } else {
          y.barWidth = customAttr.size.barWidth
          y.barGap = customAttr.size.barGap
        }
      }
      // label
      if (customAttr.label) {
        y.label = customAttr.label
      }
      y.type = 'bar'
      y.selectedMode = true
      y.select = BASE_ECHARTS_SELECT
      y.name=getStrByLang(y.name)
      y.label.formatter=getStrByLang(y.label.formatter)
      chart_option.legend.data.push(y.name)
      chart_option.series.push(y)
    }
  }

  if (customStyle.legend.group) {
    horizontalBarOptionGroup(chart_option)
  }
  componentStyle(chart_option, chart)
  seniorCfg(chart_option, chart)
  if(chart_option.tooltip.formatter){
    chart_option.tooltip.formatter=getStrByLang(chart_option.tooltip.formatter)
  }
  return chart_option
}

/**
 * 若数据有多个维度将按维度自动分组
 * @param chart_option
 */
function horizontalBarOptionGroup(chart_option) {
  const yAxisData = chart_option.yAxis.data
  const yAxisSet = new Set()
  const seriesSet = new Set()
  yAxisData.forEach((item, index) => {
    const arr = item.split('\n')
    yAxisSet.add(arr[0])
    if (arr.length > 1) {
      seriesSet.add(arr[1])
    }
  })
  if (seriesSet.size > 0) {
    chart_option.yAxis.data = Array.from(yAxisSet)

    const seriesArr = Array.from(seriesSet)
    const series = []
    seriesArr.forEach((item, index) => {
      const obj = {...chart_option.series[0], name: item}
      obj.data = obj.data.filter((item, i) => i % 2 === index)
      series.push(obj)
    })
    chart_option.series = series
    chart_option.legend.data = seriesArr
  }
}

export function horizontalStackBarOption(chart_option, chart) {
  horizontalBarOption(chart_option, chart)
  // ext
  chart_option.series.forEach(function (s) {
    s.stack = 'stack'
    s.emphasis = {
      focus: 'series'
    }
  })
  return chart_option
}

/**
 * 瀑布柱状图
 * @param chart_option
 * @param chart
 * @param activeParam
 * @returns {*}
 */
export function waterfallBarOption(chart_option, chart, activeParam) {
  // 处理shape attr
  let customAttr = {}
  if (chart.customAttr) {
    customAttr = JSON.parse(chart.customAttr)
    if (customAttr.color) {
      chart_option.color = customAttr.color.colors
    }
    // tooltip
    if (customAttr.tooltip) {
      const tooltip = JSON.parse(JSON.stringify(customAttr.tooltip))
      const reg = new RegExp('\n', 'g')
      tooltip.formatter = tooltip.formatter.replace(reg, '<br/>')
      chart_option.tooltip = tooltip

      const bgColor = tooltip.backgroundColor ? tooltip.backgroundColor : DEFAULT_TOOLTIP.backgroundColor
      chart_option.tooltip.backgroundColor = bgColor
      chart_option.tooltip.borderColor = bgColor
    }
  }

  // 处理自定义组件样式
  let customStyle = {}
  if (chart.customStyle) {
    customStyle = JSON.parse(chart.customStyle)
    if (customStyle.xAxis) {
      chart_option.xAxis.inverse = customStyle.xAxis.inverse
    }
    if (customStyle.yAxis) {
      chart_option.yAxis.inverse = customStyle.yAxis.inverse
    }
  }

  const isTotal = true;
  const isPercent = true;
  // 处理data
  if (chart.data) {
    chart_option.title.text = chart.title
    //处理多语言
    chart.data.x = getStrByLang(chart.data.x)
    chart_option.xAxis.data = chart.data.x
    if (isPercent) {
      chart_option.yAxis.min = 0
      chart_option.yAxis.maxx = 100
    }
    for (let i = 0; i < chart.data.series.length; i++) {
      const y = chart.data.series[i]
      if (isTotal && !y.isTotal) {
        let total = 0;
        y.data.forEach(item => {
          total += parseFloat(item.value)
        })
        if (isPercent) {
          y.data.forEach(item => {
            item.value = (parseFloat(item.value) / total * 100).toFixed(2)
          })
          y.data.push({
            value: 100,
            itemStyle: {
              color: '#A5B557'
            }
          })
        } else {
          y.data.push({
            value: total,
            itemStyle: {
              color: '#A5B557'
            }
          })
        }
        chart_option.xAxis.data.push('总计')
        y.isTotal = true
      }

      formatValue(y, chart)

      // color
      y.itemStyle = {
        color: hexColorToRGBA(customAttr.color.colors[i % customAttr.color.colors.length], customAttr.color.alpha)
      }

      if (customAttr.color.colorBy) {
        y.colorBy = customAttr.color.colorBy
        y.itemStyle = {}
      }
      // size
      if (customAttr.size) {
        if (customAttr.size.barDefault) {
          y.barWidth = null
          y.barGap = null
        } else {
          y.barWidth = customAttr.size.barWidth
          y.barGap = customAttr.size.barGap
        }
      }
      // label
      if (customAttr.label) {
        y.label = customAttr.label
      }
      y.type = 'bar'
      y.selectedMode = true
      y.select = BASE_ECHARTS_SELECT
      y.stack = 'Total'
      y.name=getStrByLang(y.name)
      y.label.formatter=getStrByLang(y.label.formatter)
      chart_option.legend.data.push(y.name)
      chart_option.series.push(y)
    }

    if (chart_option.series.length === 1) {
      const y = chart_option.series[0]
      const transparentData = [0]
      for (let j = 1; j < y.data.length - 1; j++) {
        transparentData[j] = parseFloat(y.data[j - 1].value) + transparentData[j - 1]
      }
      transparentData.push(0)

      chart_option.series.unshift({
        name: '',
        type: 'bar',
        stack: 'Total',
        itemStyle: {
          borderColor: 'transparent',
          color: 'transparent'
        },
        emphasis: {
          itemStyle: {
            borderColor: 'transparent',
            color: 'transparent'
          }
        },
        data: transparentData
      })
    }
  }

  componentStyle(chart_option, chart)
  seniorCfg(chart_option, chart)
  return chart_option
}

/**
 * 根据选中的数值格式统一格式化处理数据
 * @param y
 * @param chart
 */
const formatValue = (y, chart) => {
  let yAxis = []
  try {
    yAxis = JSON.parse(chart.yaxis)
  } catch (err) {
    yAxis = JSON.parse(JSON.stringify(chart.yaxis))
  }
  const f = (yAxis && yAxis.length > 0) ? yAxis[0] : null
  if (f && f.formatterCfg) {
    // 不能添加千分符，否则数值无法正常渲染
    f.formatterCfg.thousandSeparator = false
    y.data.forEach(item => {
      if (!item.isFormat) {
        // 不在末尾添加千、万、亿等中文符号，否则数值无法正确渲染
        const v = valueFormatterWithoutSuffix(item.value, f.formatterCfg)
        item.value = v.includes('NaN') ? item.value : v
        item.isFormat = true
      }
    })
  }
}
